import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import GenericViewPanel from './../GenericViewPanel';
import PersonnelsList from '../../containers/PersonnelsList';
import CreatePersonnelDialog from '../../containers/CreatePersonnelDialog';
import ButtonSearchBoxActionBar from '../ButtonSearchBoxActionBar';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

const PersonnelPanel = (props) => {
  const classes = useStyles();
  const {
    openCreatePersonnelDialog,
    searchTerm,
    handleSearchTermChange,

  } = props;

  return (
    <GenericViewPanel>
      <CreatePersonnelDialog />
      <div className={classes.actionBar}>
        <ButtonSearchBoxActionBar
          openCreateDialog={openCreatePersonnelDialog}
          searchTerm={searchTerm}
          handleSearchTermChange={handleSearchTermChange}
          buttonText="Create Personnel"
          searchPlaceholder="Search Personnel"
        />
      </div>
      <PersonnelsList />
    </GenericViewPanel>
  );
};

export default PersonnelPanel;
